import http from '@/support/services/HttpService';

const recoverUrl = '/v1/solicitarRecuperacaoDeSenha';
const changeUrl = '/v1/recuperarSenha';

class RecoverService {
  static recover(data) {
    return http.post(`${recoverUrl}`, data);
  }

  static change(data) {
    return http.post(`${changeUrl}`, data);
  }
}

export default RecoverService;
